import { createContext, useContext, useState, useEffect } from 'react';
import API_BASE_URL from '../config/api';
// Auth Context oluştur
const AuthContext = createContext();

// Auth Provider component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Sayfa yenilendiğinde token kontrolü
  useEffect(() => {
    const token = sessionStorage.getItem('token');
    const userData = sessionStorage.getItem('user');

    if (token && userData) {
      try {
        // 🔥 BASİT TOKEN KONTROLÜ
        const tokenData = JSON.parse(atob(token.split('.')[1]));
        const isTokenValid = Date.now() < tokenData.exp * 1000;

        if (isTokenValid) {
          setUser(JSON.parse(userData));
          console.log('✅ Token valid, user logged in');
        } else {
          console.log('❌ Token expired, clearing...');
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          setUser(null);
        }
      } catch (error) {
        console.log('❌ Invalid token, clearing...');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        setUser(null);
      }
    }

    setLoading(false);
  }, []);

  // Login fonksiyonu
  const login = async (email, password) => {
    try {
      console.log('🔄 Login attempt:', email);

      const response = await fetch('https://medi-panel.cloud/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      console.log('📡 Response status:', response.status);

      if (!response.ok) {
        throw new Error(`Login failed: ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ Login successful:', data);

      // Token ve user bilgilerini kaydet - HEM sessionStorage HEM localStorage'a (tutarlılık için)
      sessionStorage.setItem('token', data.token);
      localStorage.setItem('token', data.token); // 🔥 YENİ: localStorage'a da kaydet
      sessionStorage.setItem('user', JSON.stringify({
        email: data.email,
        role: data.role
      }));
      localStorage.setItem('user', JSON.stringify({ // 🔥 YENİ: localStorage'a da kaydet
        email: data.email,
        role: data.role
      }));

      // 🔥 STATE GÜNCELLEMESİNİ GÜÇLENDİR
      const userData = { email: data.email, role: data.role };
      console.log('🔄 Setting user state:', userData);
      setUser(userData);
      console.log('✅ User state set completed');
      return data;
    } catch (error) {
      console.error('❌ Login error:', error);
      throw error;
    }
  };

  // Logout fonksiyonu
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    setUser(null);
  };

  // Context value
  const value = {
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};